// Used only when the host sent no uploader restrictions.
export const DEFAULT_DROPPABLE_TYPES = [
  'image/png',
  'image/jpeg',
  'image/jpg',
  'image/svg',
  'image/svg+xml',
  'application/pdf',
  'image/heic',
  'image/heif',
];

/**
 * Whether a file dropped on the editor may be uploaded. Follows the uploader's `allowedFileTypes`
 * (the list "Choose file" uses), with the same rules as Uppy: a MIME type (`image/tiff`),
 * a MIME wildcard (`image/*`) or a file extension (`.heic`).
 */
function isDroppableFile(file: File, allowedFileTypes: string[] | undefined): boolean {
  const allowed = allowedFileTypes?.length ? allowedFileTypes : DEFAULT_DROPPABLE_TYPES;
  const fileType = file.type.toLowerCase();
  const fileName = file.name.toLowerCase();

  return allowed.some((rawType) => {
    const type = rawType.trim().toLowerCase();
    if (type.startsWith('.')) {
      return fileName.endsWith(type);
    }
    if (!fileType) {
      return false;
    }
    if (type.endsWith('/*')) {
      return fileType.startsWith(type.slice(0, -1));
    }
    return fileType === type;
  });
}

export default isDroppableFile;
